import { useOutletContext } from 'react-router-dom';

/**
 * Default panel shown at /wiki/:spaceKey with no page selected.
 */
export default function SpaceHome() {
  const { space } = useOutletContext();
  return (
    <div style={{ padding: '40px 32px', maxWidth: 720, margin: '0 auto', textAlign: 'center' }}>
      <div style={{ fontSize: 56 }}>{space.icon}</div>
      <h1 style={{ marginBottom: 4 }}>{space.name}</h1>
      <p className="muted">{space.description || 'No description set for this space.'}</p>
      <p className="muted small" style={{ marginTop: 24 }}>Pick a page from the sidebar, or create a new one.</p>
    </div>
  );
}
